// extracted by mini-css-extract-plugin
module.exports = {"header":"i_I","body":"i_J","image":"i_K","form-group":"i_L"};